import React from 'react'
import Checkbox from '../DMGComponents/Checkbox'
import Button from '../DMGComponents/Button'
import Break from '../DMGComponents/Break'
import ContentIcon from '../assets/img/Folder.png'
import '../assets/css/Table.css'
import getUid from '../utils/uidGenerator';
import { deleteFiles, getAreaContent, getDownloadInfo, getAreaContentForApproval, getDownloadInfoForApproval } from '../fetchData';
import toast, { Toaster } from 'react-hot-toast';
import Spinner from './Spinner';
import { AreaContext } from './AreaContext';

class AreaContent extends React.Component {
    static contextType = AreaContext;
    constructor(props) {
        super(props);

        this.state = {
            selectedArea: this.props.area,
            areaContent: [],
            errorLoading: false,
            isLoading: false,
            allSelected: false,
            fileSelected: false
        }

        this.refreshAreaContent = this.refreshAreaContent.bind(this);
        this.downloadFiles = this.downloadFiles.bind(this);
    }

    componentDidMount() {
        this.props.refreshAreaContent(this.refreshAreaContent);
        this.refreshAreaContent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.area.id !== this.props.area.id) {
            this.setState({ selectedArea: this.props.area });
            this.refreshAreaContent();
        }
    }

    refreshAreaContent = () => {
        this.loadAreaContent(this.props.area.id);
    }

    loadAreaContent = (areaId) => {
        this.setState({
            isLoading: true
        })

        if (this.props.isApprovalMode) {
            getAreaContentForApproval(areaId).then((res) => {
                this.fillAreaContent(res)
            }).catch((err) => {
                this.onGetAreaContentError(err);
            })
        }
        else {
            getAreaContent(areaId).then((res) => {
                this.fillAreaContent(res)
            }).catch((err) => {
                this.onGetAreaContentError(err);
            })
        }
    }

    fillAreaContent = (res) => {
        const { setAreaContentLength } = this.context;
        let arr = []
        let overallSize = 0
        res.forEach(e => {
            arr.push({
                selected: false,
                fileName: e.fileName,
                size: e.sizeInBytes,
                timestamp: new Date(e.lastWriteTime)
            })
            overallSize += e.sizeInBytes
        })
        this.props.updateAreaUsedSpace(overallSize)
        this.setState({
            areaContent: arr,
            errorLoading: false,
            isLoading: false,
            fileSelected: false
        })
        setAreaContentLength(arr.length)
    }

    onGetAreaContentError = (err) => {
        console.error("Error", err);
        this.setState({
            errorLoading: true,
            isLoading: false,
            fileSelected: false
        })
        toast.error("Error loading area content.")
    }

    downloadFiles = () => {
        let selectedFiles = []
        for (var i = 0; i < this.state.areaContent.length; i++) {
            let file = this.state.areaContent[i];
            if (file.selected) {
                selectedFiles.push(file.fileName);
            }
        }
        if (selectedFiles.length > 0) {
            this.setState({
                isLoading: true
            })
            if (this.props.isApprovalMode) {
                getDownloadInfoForApproval(this.state.selectedArea.id, selectedFiles).then((res) => {
                    this.goDownloadFiles(res);
                }).catch((err) => {
                    this.onDownloadFilesError(err);
                })
            }
            else {
                getDownloadInfo(this.state.selectedArea.id, selectedFiles).then((res) => {
                    this.goDownloadFiles(res);
                }).catch((err) => {
                    this.onDownloadFilesError(err);
                })
            }
            
        }
    }

    goDownloadFiles = (res) => {
        this.setState({
            isLoading: false
        })
        let downloadGuid = res;
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
        window.location = baseUrl + "api/download/files/" + downloadGuid;
        toast.success("Downloading file(s).")
    }

    onDownloadFilesError = (err) => {
        console.error("Error", err)
        toast.error("Error downloading file(s).");
        this.setState({
            isLoading: false
        })
    }

    deleteFile = (file) => {
        let selectedFiles = []
        selectedFiles.push(file.fileName);
        this.setState({
            isLoading: true
        })
        if (selectedFiles.length > 0) {
            deleteFiles(this.props.area.id, selectedFiles).then(() => {
                this.refreshAreaContent();
                toast.success("File deleted.")
            }).catch((err) => {
                console.error("Error", err)
                toast.error("Error deleting file.")
                this.setState({
                    isLoading: false
                })
            })
        }
    };

    deleteFiles = () => {
        let selectedFiles = []
        for (var i = 0; i < this.state.areaContent.length; i++) {
            let file = this.state.areaContent[i];
            if (file.selected) {
                selectedFiles.push(file.fileName);
            }
        }

        if (selectedFiles.length > 0) {
            this.setState({
                isLoading: true
            })
            deleteFiles(this.props.area.id, selectedFiles).then(() => {
                this.refreshAreaContent();
                toast.success("Files deleted.")
            }).catch((err) => {
                console.error("Error", err)
                toast.error("Error deleting files.")
                this.setState({
                    isLoading: false
                })
            })
        }
    };

    selectFile = (i) => {
        let arr = this.state.areaContent;
        arr[i].selected = !arr[i].selected
        let newAllSelected = this.state.allSelected;
        if (!arr[i].selected && this.state.allSelected) {
            newAllSelected = false;
        }
        let anyFileSelected = this.isAnyFileSelected();
        this.setState({
            areaContent: arr,
            allSelected: newAllSelected,
            fileSelected: anyFileSelected,
        })
    }

    selectAllFiles = (i) => {
        let arr = this.state.areaContent;
        let select = !this.state.allSelected;
        for (var i = 0; i < arr.length; i++) {
            arr[i].selected = select;
        }
        this.setState({
            areaContent: arr,
            allSelected: select,
            fileSelected: select,
        })
    }

    isAnyFileSelected = () => {
        let selected = false;
        for (var i = 0; i < this.state.areaContent.length; i++) {
            let file = this.state.areaContent[i];
            if (file.selected) {
                selected = true;
                break;
            }
        }
        return selected;
    }

    generateTableBody = (array) => {
        return array.map((e, i) => {
            return (
                <tr
                    style={{ cursor: "pointer" }}
                    key={getUid()}
                >
                    <td onClick={() => { this.selectFile(i) }}>
                        <Checkbox style={{ marginLeft: 15 }} checked={e.selected} onClick={(s) => { this.state.areaContent[i].selected = s }} />
                    </td>
                    <td onClick={() => { this.selectFile(i) }}>
                        {e.fileName}
                    </td>
                    <td onClick={() => { this.selectFile(i) }} style={{ textAlign: "center" }}>
                        {Math.round(e.size / 10000 + 100 * Number.EPSILON) / 100 /* Epsilon necessary due to floatingpoint conversion (see 0.1 + 0.2  != 0.3 in javascript) */}
                    </td>
                    <td onClick={() => { this.selectFile(i) }} style={{ textAlign: "center" }}>
                        {e.timestamp.toLocaleString()}
                    </td>
                    {this.state.selectedArea.allowWrite && <td onClick={() => { this.deleteFile(e) }}><i className="ci-icon ci-icon-ic-close"></i></td>}
                </tr>
            )
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <Break style={{ margin: "16px 0 12px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={ContentIcon}
                                alt="Area Content"
                                style={{ height: "2rem", position: "absolute" }}
                                />
                        </div>
                        <div>
                            Area Content
                        </div>
                    </div>
                </Break>
                {this.state.errorLoading
                    ? <h3>Error loading area content</h3>
                    : <div>
                        {this.state.isLoading &&
                            <><div style={{ textAlign: "center" }}>
                                <Spinner />
                            </div></>
                        }
                        {!this.state.isLoading &&
                            <div>
                                <table
                                    style={{ width: "100%" }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={{ width: "30px", textAlign: "center" }}><Checkbox key={getUid()} style={{ marginLeft: 15 }} checked={this.state.allSelected} onClick={() => { this.selectAllFiles() }} /></th>
                                            <th>File</th>
                                            <th style={{ width: "60px", textAlign: "center" }}>Filesize (MB)</th>
                                            <th style={{ width: "180px", textAlign: "center" }}>LastWriteTime</th>
                                            {this.state.selectedArea.allowWrite && <th style={{ width: "30px", textAlign: "center" }}>Delete</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.generateTableBody(this.state.areaContent)}
                                    </tbody>
                                </table>
                                <br />
                                {this.state.areaContent.length == 0 &&
                                    <div style={{textAlign:"center", fontSize:"20px"}}>No Files Found</div>
                                }
                                {this.state.areaContent.length > 0 &&
                                    <React.Fragment>
                                        {!this.state.fileSelected &&
                                            <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>Please select files from the list above.</div>
                                        }
                                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px" }}>
                                            {this.state.selectedArea.allowWrite &&
                                                <span style={{ marginRight: "12px" }}>
                                                    <Button type="hover-bottom-left" onClick={this.deleteFiles} disabled={!this.state.fileSelected}>Delete</Button>
                                                </span>
                                            }
                                            <Button type="hover-bottom-left" onClick={this.downloadFiles} disabled={!this.state.fileSelected}>Download</Button>
                                        </div>
                                    </React.Fragment>
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default AreaContent;